import { paginatedListSerializer, ResourceAction } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

export interface RoleReference {
  uuid: string;
}

export interface UpdateGroupInput {
  name: string;
  roles: RoleReference[];
}

export interface GroupListFilters {
  limit?: number;
  offset?: number;
  searchText?: string;
}
export interface GroupSimple {
  uuid: string;
  name: string;
}

export interface NewGroupInput {
  uuid: string;
  name: string;
  roles: RoleReference[];
}

export interface GroupDto {
  uuid: string;
  name: string;

  roles: {
    uuid: string;
    name: string;
  }[];
}

const list = ResourceAction({
  name: "list",
  method: "get",
  path: "",
  querySerializer: MSerializers.object<GroupListFilters>({
    searchText: MSerializers.string.optional(),
    limit: MSerializers.integer.optional(),
    offset: MSerializers.integer.optional(),
  }),
  responseSerializer: paginatedListSerializer(
    MSerializers.object<GroupSimple>({
      name: MSerializers.string,
      uuid: MSerializers.uuid(),
    }),
  ),
});
